import Vue from "vue";
import VueRouter from "vue-router";

import Devices from "../views/Devices.vue";

// Docs
import DocsIndex from "../views/docs/Index.vue";
import GettingStarted from "../views/docs/GettingStarted.vue";
import Firebase from "../views/docs/Firebase.vue";
import Device from "../views/docs/Device.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Devices",
    component: Devices,
  },
  {
    path: "/docs",
    component: DocsIndex,

    props: true,
    children: [
      {
        path: "", //selected tab by default
        name: "docs",
        component: GettingStarted,
      },
      {
        path: "/docs/firebase", //selected tab by default
        component: Firebase,
      },
      {
        path: "/docs/device", //selected tab by default
        component: Device,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
